// extracted by mini-css-extract-plugin
export default {"buttons":"ReceivablesPage_buttons__-chcb","filter":"ReceivablesPage_filter__Tn++F","tax":"ReceivablesPage_tax__rSGax","state":"ReceivablesPage_state__pRFy4"};